import classNames from "classnames";
import moment from "moment";
import React, { useContext } from "react";
import ItineraryAppointmentRow from "./ItineraryAppointmentRow";
import { getId, ItinerarySidebarItem, LinkedItineraryItems } from "./utils";
import { PlanningContext } from "PlanningContext/PlanningContext";

interface Props {
  item: ItinerarySidebarItem
  artist: server.dto.ArtistSmall
  dayAppointments: server.dto.PlannerDay

  linkedItems: LinkedItineraryItems
  toggleLinked: (appointment: server.dto.PlannerAppointment) => void

  onHoveringOver: (appointment: server.dto.PlannerAppointment) => void
  hoveringOver: server.dto.PlannerAppointment
  canCreateNewAppointment: boolean
  canLinkUnlinkTravel: boolean
  canLinkUnlinkShow: boolean
}

const ItineraryDay = (props: Props) => {
  const planningContext = useContext(PlanningContext);
  const hasAppointments = props.dayAppointments.appointments.length > 0;
  const dayRowSpan = hasAppointments ? props.dayAppointments.appointments.length : 1;

  const trClasses = classNames({
    noappointments: !hasAppointments
  });

  const appointmentMoment = moment.utc(props.dayAppointments.date);

  const onDayClicked = () => {
    if (!props.canCreateNewAppointment) {
      return;
    }

    planningContext.open({
      date: appointmentMoment,
      artist: props.artist,
      fromShowId: props.item.type === "show" ? props.item.itemId : undefined,
    });
  };

  const dayTdStyle: React.CSSProperties = props.canCreateNewAppointment
    ? undefined
    : {
      cursor: "default"
    };

  const firstAppointment = props.dayAppointments.appointments[0];

  return <>
    <tr className={trClasses}>
      <td className="day" style={dayTdStyle} rowSpan={dayRowSpan} onClick={onDayClicked}>
        {appointmentMoment.format("ddd")} {appointmentMoment.toDate().getUTCDate()}
        <br />
        {appointmentMoment.format("MMM")}
      </td>
      {!hasAppointments && <td colSpan={10}></td>}
      {hasAppointments &&
        <ItineraryAppointmentRow
          onHoverOver={props.onHoveringOver}
          hoveringOver={props.hoveringOver}
          appointment={firstAppointment}
          linkedItems={props.linkedItems}
          toggleLinked={props.toggleLinked}
          item={props.item}
          canCreateNewAppointment={props.canCreateNewAppointment}
          canLinkUnlinkTravel={props.canLinkUnlinkTravel}
          canLinkUnlinkShow={props.canLinkUnlinkShow}
        />}
    </tr>
    {props.dayAppointments.appointments.slice(1).map(app => (
      <tr key={getId(app)}>
        <ItineraryAppointmentRow
          onHoverOver={props.onHoveringOver}
          hoveringOver={props.hoveringOver}
          appointment={app}
          linkedItems={props.linkedItems}
          toggleLinked={props.toggleLinked}
          item={props.item}
          canCreateNewAppointment={props.canCreateNewAppointment}
          canLinkUnlinkTravel={props.canLinkUnlinkTravel}
          canLinkUnlinkShow={props.canLinkUnlinkShow}
        />
      </tr>
    ))}
  </>;
};

export default ItineraryDay;